<template>
  <div class="dettaglio-trasferte-mobile mobile_customize col-xs-2" v-loading="loading">

    <div class="header-tab row row-custom" v-show="showPrincipal">
      <div class="col-4 no-padding icon-return">
        <el-button>
          <icon v-if="$route.name === 'home' ? false : true" name="riv-arrow2" scale="1.4" flip="horizontal"
            @click.native="link('RiepilogoAutorizzazioni')"></icon>
        </el-button>
      </div>
      <div class="mobile-title-2line col-16 no-padding">
        {{ $t('autorizza.label.title').toUpperCase() }}
        <span class="subtitle">{{ getStato() }}</span>
      </div>
      <div class="col-4 no-padding">
        <div class="send" v-if="trasferta.statoAvanz === '1'">
          <el-tooltip placement="left" popper-class="popover-mobile" effect="light">
            <div slot="content">
              <div @click="actionTrasferta('2')">
                <span>{{ $t('btn.rifiuta') }}</span>
              </div>
              <div @click="actionTrasferta('3')">
                <span>{{ $t('btn.approva') }}</span>
              </div>
            </div>

            <icon class="pointer action" name="riv-more" scale="2"></icon>

          </el-tooltip>
        </div>
      </div>
    </div>

    <div class="testata-trasferta" v-show="showPrincipal">
      <div class="elemento row row-custom">
        <div class="label col-22 no-padding">{{ $t('autorizza.label.periodo') }}</div>
        <div class="label col-2 no-padding">
          <icon v-if="testata" name="riv-downArr" scale="1" flip="vertical" @click.native="testata = !testata"></icon>
          <icon v-else name="riv-downArr" scale="1" @click.native="testata = !testata"></icon>
        </div>
        <div class="value col-24 no-padding">{{ trasferta.dataDal | formattaData }} - {{ trasferta.dataAl | formattaData
          }}</div>
      </div>
      <div v-show="testata">
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('autorizza.label.partenza') }}</div>
          <div class="value col-24 no-padding">{{ trasferta.desProv }}</div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('autorizza.label.destinazione') }}</div>
          <div class="value col-24 no-padding">{{ trasferta.desDest === undefined ? trasferta.desMan :
            trasferta.desDest}}</div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('autorizza.label.soc') }}</div>
          <div class="value col-24 no-padding"> {{ trasferta.desCli }}</div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('autorizza.label.uffRep') }}</div>
          <div class="value col-24 no-padding">{{ trasferta.desUff }}</div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('autorizza.label.referente') }}</div>
          <div class="value col-24 no-padding">
            <el-tag :key="tag.mail" v-for="tag in trasferta.contatti" :disable-transitions="false">
              {{ tag.mail }}
            </el-tag>
            {{ trasferta.perRif }}
          </div>
        </div>
        <div class="elemento row row-custom">
          <div class="label col-24 no-padding">{{ $t('autorizza.label.motivo') }}</div>
          <div class="value col-24 no-padding" v-html="getMotivo(trasferta.notaDip)" style="white-space: pre-line">
          </div>
        </div>
      </div>
      <div class="elemento row row-custom">
        <div class="label col-24 no-padding">{{ $t('autorizza.label.notaResp') }}</div>
        <div class="el-form-input col-24 no-padding" style="height: 100%;">
          <div class="input-wrapper">
            <textarea type="text" v-model="trasferta.notaResp" class="first" rows="5"
              :disabled="trasferta.statoAvanz !== '1'" />
          </div>
        </div>
      </div>
    </div>

    <div class="dettaglio-diario">
      <span class="info-diario">{{ $t('autorizza.label.authDiary') }}</span>
      <div class="select-wrapper">
        <select v-model="statusDiario" @change="loadDiario">
          <option v-for="item in stati" :value="item.id" :key="item.id">{{ item.desc }}</option>
        </select>
      </div>

      <el-table :data="diario" class="el-table_mobile" :empty-text="$t('autorizza.msg.noData')">
        <el-table-column width="30">
          <template slot-scope="scope">
            <div class="data-wrapper">
              <el-tooltip class="item" effect="dark" :content="$t('statusDett.' + scope.row.statoAvanz)"
                placement="top-start">
                <icon :name="getStatoIcon_dett(scope.row.statoAvanz)" :class="getStatoClass_dett(scope.row.statoAvanz)"
                  scale="1.2"></icon>
              </el-tooltip>
            </div>
          </template>

        </el-table-column>


        <el-table-column header-align="center" align="center" :label="$t('autorizza.label.giorno')" width="100"
          class-name="sfondino">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <span class="block">{{ scope.row.giorno | formattaData }}</span>
              <span class="block"> {{ scope.row.oraDal | formattaHours }} / {{ scope.row.oraAl | formattaHours }}</span>
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="desDest" align="center" :label="$t('autorizza.label.destinazione')">

          <template slot-scope="scope">
            <div class="name-wrapper truncate-overflow">
              {{ scope.row.desDest }}
            </div>
          </template>

        </el-table-column>

        <el-table-column header-align="center" align="center" width="30">

          <template slot-scope="scope">
            <div class="name-wrapper" :key="scope.length" @click.stop.prevent v-if="enableAction(scope.row)">
              <el-tooltip placement="left" popper-class="popover-mobile" effect="light">
                <template slot="content">
                  <div @click="actionDiario(scope.row, '3')">
                    <span>{{ $t('btn.approva') }}</span>
                  </div>
                  <div @click="actionDiario(scope.row, '2')">
                    <span>{{ $t('btn.rifiuta') }}</span>
                  </div>
                </template>

                <icon class="pointer action" name="riv-more" scale="1.5"></icon>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>



    </div>

  </div>
</template>
<script>
import moment from 'moment'

export default {
  components: {},
  name: 'AuorizzaTrasfertaMobile',
  i18n: {
    messages: {
      it_IT: {
        autorizza: {
          label: {
            title: 'Trasferta',
            periodo: 'Periodo',
            dataIn: 'Data Inizio',
            dataFin: 'Data Fine',
            partenza: 'Partenza',
            destinazione: 'Destinazione',
            soc: 'Per conto della Società',
            uffRep: 'Ufficio/Reparto',
            referente: 'Persona di Riferimento',
            motivo: 'Motivazione',
            giorno: 'Giorno',
            orario: 'Orario',
            notaResp: 'Nota Responsabile',
            authDiary: 'Vengono visualizzate solo le righe del diario che differiscono dalla destinazione di default'
          },
          msg: {
            respAppDiary: 'Sei sicuro di voler Approvare la riga di Diario',
            respRejDiary: 'Sei sicuro di voler Rifiutare la riga di Diario',
            respAppTrip: 'Sei sicuro di voler Approvare la Trasferta',
            respRejTrip: 'Sei sicuro di voler Rifiutare la Trasferta',
            info: 'Avviso!',
            abort: 'Operazione Annullata',
            noData: 'Nessun Documento trovato'
          }
        }
      },
      fr_FR: {
        autorizza: {
          label: {
            title: 'Deplacement',
            periodo: 'Date du-au',
            dataIn: 'Date du',
            dataFin: 'Date au',
            partenza: 'Départ',
            destinazione: 'Destination',
            soc: 'Pour le compte',
            uffRep: 'Bureau/département',
            referente: 'Personne de référence',
            motivo: 'Motif',
            giorno: 'Jour',
            orario: 'Horaire',
            notaResp: 'Responsable notes',
            authDiary: 'Sont visualisées seulement les lignes du journal de voyage que different de la destination de default.'
          },
          msg: {
            respAppDiary: 'Êtes-vous sur d\'approuver la ligne du jurnal de voyage?',
            respRejDiary: 'Êtes-vous sur de refuser la ligne du jurnal de voyage?',
            respAppTrip: 'Êtes-vous sur d\'approuver le déplacement?',
            respRejTrip: 'Êtes-vous sur de refuser le déplacement?',
            info: 'Info!',
            abort: 'Opération annulée',
            noData: 'Aucun document trouvé'
          }
        }
      },
      es_ES: {
        autorizza: {
          label: {
            title: 'Viaje',
            periodo: 'Fecha desde-hasta',
            dataIn: 'Dia salida',
            dataFin: 'Dia regreso',
            partenza: 'Salida',
            destinazione: 'Destino',
            soc: 'Por cuenta de la sociedad',
            uffRep: 'Oficina/Empresa',
            referente: 'Persona de referencia',
            motivo: 'Referencia',
            giorno: 'Día',
            orario: 'Horas',
            notaResp: 'Nota Responsables',
            authDiary: 'Solo se muestran las líneas del registro de viaje que son diferentes del destino predeterminado.'
          },
          msg: {
            respAppDiary: '¿Está seguro que quiere aprobar la linea de la agenda?',
            respRejDiary: '¿Está seguro que quiere rechazar la linea de la agenda?',
            respAppTrip: '¿Está seguro de que desea aprobar la solicitud de viaje?',
            respRejTrip: '¿Está seguro que quiere rechazar la solicitud de viaje?',
            info: '¡Aviso!',
            abort: 'Operación cancelada',
            noData: 'Sin informacion'
          }
        }
      },
      de_DE: {
        autorizza: {
          label: {
            title: 'Dienstreise',
            periodo: 'Datum von-bis',
            dataIn: 'Reisebeginn',
            dataFin: 'Reiseende',
            partenza: 'Abreiseort',
            destinazione: 'Reiseziel',
            soc: 'auf Kosten der Firma',
            uffRep: 'Büro/Abteilung',
            referente: 'Ansprechpartner',
            motivo: 'Grund',
            giorno: 'Tag',
            orario: 'Zeitraum',
            notaResp: 'Verantwortliche Notiz',
            authDiary: 'Es werden nur Journalzeilen angezeigt, die vom Standardziel abweichen'
          },
          msg: {
            respAppDiary: 'Sind Sie sicher, dass Sie diese Reihe bestätigen möchten?',
            respRejDiary: 'Sind Sie sicher, dass Sie diese Reihe ablehnen möchten?',
            respAppTrip: 'Sind Sie sicher, dass Sie den Reiseantrag bestätigen möchten?',
            respRejTrip: 'Sind Sie sicher, dass Sie den Reiseantrag ablehnen möchten?',
            info: 'Beachten!',
            abort: 'Operation abgebrochen',
            noData: 'Kein Dokument gefunden'
          }
        }
      },
      en_GB: {
        trasferte: {}
      }
    }
  },
  data() {
    return {
      loading: false,
      idTrasferta: '',
      trasferta: {},
      form: {},
      diario: [],
      filterStato: '',
      currentPage: '1',
      pag_for: '8',
      pag_order: 'DD',
      stati: [
        { id: 'all', desc: this.$t('status.all'), icon: 'riv-tick' },
        { id: '0', desc: this.$t('status.0'), icon: 'riv-tick' },
        { id: '1', desc: this.$t('status.1'), icon: 'riv-tick' },
        { id: '2', desc: this.$t('status.2'), icon: 'riv-tick' },
        { id: '3', desc: this.$t('status.3'), icon: 'riv-tick' },
        { id: '4', desc: this.$t('status.4'), icon: 'riv-tick' },
        { id: '7', desc: this.$t('status.7'), icon: 'riv-tick' }
      ],
      statusDiario: 'all',
      showPrincipal: true,
      testata: true
    }
  },
  filters: {
    /* Formatta la data: GGMMAAAA --> GG/MM/AAAA */
    formattaData: function (date) {
      if (date !== '' && date !== undefined) {
        return moment(date, 'YYYYMMDD').format('DD/MM/YYYY')
        // return date.substr(6, 2) + '/' + date.substr(4, 2) + '/' + date.substr(0, 4)
      } else {
        return ' '
      }
    },
    formattaHours: function (hours) {
      if (hours !== '') {
        return hours.replace(',', ':')
      } else {
        return ' '
      }
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.name === 'AutorizzaTrasferta') {
        this.loading = true
        this.idTrasferta = this.$route.params.id
        this.loadTrasferta(this.$route.params.id)
      }
    }
  },
  beforeMount: function () {
    this.loading = true
    this.idTrasferta = this.$route.params.id
    this.loadTrasferta(this.$route.params.id)
  },
  mounted: function () {
  },
  methods: {
    link: function (route) {
      this.$router.push({ name: route })
    },
    loadTrasferta: function (idTrasferta) {
      this.loading = true
      this.$set(this, 'form', JSON.parse(sessionStorage.getItem('Trasferte_form')))
      this.$http.get('trasferte/' + this.$store.state.country + '/trasferte', {
        params: {
          idTrasferta: idTrasferta,
          vista: 'C'
          //daGestire: (this.form !== null && this.form.daGestire !== undefined && !this.form.daGestire) ? 'no' : 'si'
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.trasferta = response.body.data[0]
            this.loadDiario('all')
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    loadDiario: function (stato) {
      this.$set(this, 'diario', [])
      this.loading = true
      let obj = {
        params: {
          'idTrasferta': this.trasferta.idTrasferta,
          'pag_action': (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          'pag_from': this.currentPage,
          'pag_for': this.pag_for,
          'pag_order': this.pag_order,
          'vista': 'R',
          'ccDipendente': this.trasferta.ccDipendente,
          'dataDal': this.trasferta.dataDal,
          'dataAl': this.trasferta.dataAl
        }
      }
      if (stato !== '' && stato !== 'all') {
        obj.params['statoRighe'] = stato
      }
      this.$http.get('trasferte/' + this.$store.state.country + '/diario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.diario = response.body.data
          }
          this.loading = false
        })
    },
    actionTrasferta: function (stato) {
      let _this = this
      let message = stato === '3' ? this.$i18n.t('autorizza.msg.respAppTrip') : this.$i18n.t('autorizza.msg.respRejTrip')
      let btnAction = stato === '3' ? this.$i18n.t('btn.confermaApp') : this.$i18n.t('btn.confermaRej')
      this.$confirm(
        message, this.$i18n.t('autorizza.msg.info'), {
        confirmButtonText: btnAction,
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.setTrasferta(stato)
          } else {
            _this.$message({
              showClose: true,
              message: _this.$i18n.t('autorizza.msg.abort'),
              type: 'info',
              duration: process.env.duration
            })
          }
        }
      })
    },
    setTrasferta: function (statoAvanz) {
      this.loading = true
      let obj = {
        'idTrasferta': this.idTrasferta,
        'operazione': '*UPD',
        'statoAvanz': statoAvanz,
        'notaRes': this.trasferta.notaRes
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/trasferta', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    actionDiario: function (row, stato) {
      let _this = this
      this.$confirm(
        stato === '3' ? this.$i18n.t('autorizza.msg.respAppDiary') : this.$i18n.t('autorizza.msg.respRejDiary'),
        this.$i18n.t('autorizza.msg.info'), {
        confirmButtonText: this.$i18n.t('btn.conferma'),
        cancelButtonText: this.$i18n.t('btn.annulla'),
        type: 'info',
        callback: function (row, action) {
          if (action === 'confirm') {
            _this.setDiario(stato)
          } else {
            _this.$message({
              showClose: true,
              message: _this.$i18n.t('autorizza.msg.abort'),
              type: 'info',
              duration: process.env.duration
            })
          }
        }
      })
    },
    setDiario: function (row, statoAvanz) {
      this.loading = true
      let obj = {
        idTrasferta: this.idTrasferta,
        statoAvanz: statoAvanz,
        righeDiario: [{
          id: row.id
        }],
        numRigheDiario: 1
      }
      this.$http.post('trasferte/' + this.$store.state.country + '/statodiario', obj)
        .then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
            this.loadDiario()
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
    },
    getStatoIcon_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'riv-save2'
        case '1':
          return 'riv-save2'
        case '2':
          return 'riv-user'
        case '3':
        case '4':
          return 'riv-alloggio'
        default:
          return ''
      }
    },
    getStatoClass_dett: function (stato) {
      switch (stato) {
        case '0':
          return 'status-saved'
        case '1':
          return 'status-send'
        case '2':
          return 'status-rejected'
        case '3':
          return 'status-approved'
        case '4':
          return 'status-send'
        default:
          return ''
      }
    },
    getStato: function () {
      if (this.trasferta.terminata === 'T') {
        return '(' + this.$i18n.t('status.t') + ')'
      } else {
        return '(' + this.$i18n.t('status.' + this.trasferta.statoAvanz) + ')'
      }
    },
    enableAction: function (row) {
      let statoTrasferta = this.trasferta.statoAvanz
      if (this.trasferta.terminata === 'T') {
        return false
      }
      if ((statoTrasferta === '3' || statoTrasferta === '4' || statoTrasferta === '6') && row.statoAvanz === '1') {
        return true
      }
      return false
    },
    getMotivo: function (nota) {
      return nota !== undefined ? nota.replace(/\\n|\\r\\n|\\n\\r|\\r/g, '<br>') : ''
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";
@import "../../assets/less/mobile_customize.less";
@import "../../assets/less/el-table_mobile.less";
@import "../../assets/less/el-form_mobile.less";

.dettaglio-trasferte-mobile {
  padding: 0;

  .header-tab {
    height: 40px;
    // border-bottom: 1px solid #007c74;
    text-align: center;
    margin-bottom: 20px;

    .icon-return {
      line-height: 65px;

      .el-button {
        height: 40px;
        width: 40px;
        // border-radius: 0px;
        //margin-top: 12px;
        //margin-left: 10px;
        padding: 0px;
        color: @greenRiva;
        float: left;
        border: none;
      }

      .el-button:hover {
        background-color: @white;
      }
    }

    .send {
      line-height: 40px;
      // position: fixed;
      // right: 20px;
      // bottom: 20px;
      float: right;
      color: #FF791A;
      // margin-right: 10px;
      margin-left: 10px;

      span {
        display: block;
        line-height: 10px;
        .set-font(@family: "os-regular", @size: 10px, @color: #bb515c);
        text-transform: uppercase;
      }
    }
  }

  .testata-trasferta {
    background-color: #f2fbfb;
    border: 1px solid @greyLine;
    padding: 5px;

    .label {
      line-height: 20px;
      text-align: left;
      .set-font(@family: "os-bold", @size: 14px);
    }

    .value {
      line-height: 20px;
      text-align: left;
      .set-font(@family: "os-regular", @size: 14px, @color: #969696);
    }

    .el-form-input {
      height: 45px;
      line-height: 30px;

      &.padding-right {
        padding-left: 0 !important;
        padding-right: 5px !important;
      }

      &.padding-left {
        padding-left: 5px !important;
        padding-right: 0 !important;
      }

      .input-wrapper {
        height: 38px;

        input {
          .set-font(@family: "os-regular", @size: 14px, @color: #969696);
          border: 1px solid #969696;
          height: 38px;
          width: 100%;
          padding-right: 24px;
          background-color: #fff;
          border-radius: 5px;

          text-align: left;
          // margin: 3px;
          padding: 3px;
          -webkit-appearance: none;

          &.first {
            float: left;
          }

          &.second {
            float: right;
          }

          &.field-disabled {
            background-color: @greyRicerca !important; //@grayLight !important;
            color: @grayMedium !important; // @grayTesto !important;
            -webkit-text-fill-color: @grayMedium;
            opacity: 1;
            /* required on iOS */
          }
        }
      }
    }

    textarea {
      .set-font(@family: "os-regular", @size: 14px, @color: #969696);
      border: 1px solid #969696;
      //height: 100%;
      width: 100%;
      padding-right: 24px;
      background-color: #fff;
      border-radius: 5px;

      text-align: left;
      // margin: 3px;
      padding: 3px;
      -webkit-appearance: none;

      &.first {
        float: left;
      }

      &.second {
        float: right;
      }

      &.field-disabled {
        background-color: @greyRicerca !important; //@grayLight !important;
        color: @grayMedium !important; // @grayTesto !important;
        -webkit-text-fill-color: @grayMedium;
        opacity: 1;
        /* required on iOS */
      }
    }
  }

  .dettaglio-diario {
    margin-top: 15px;

    .select-wrapper {
      margin-top: 15px;
      position: relative;
      display: inline-block;
      width: 100%;
      height: 38px;

      &:after {
        content: "\0025BC";
        // font: normal normal normal 12px/1 FontAwesome;
        color: #969696;
        right: 15px;
        top: -5px;
        height: 26px;
        padding: 15px 0px 0px 8px;
        position: absolute;
        pointer-events: none;
      }

      select {
        .set-font(@family: "os-regular", @size: 14px, @color: #969696);
        height: 38px;
        width: 100%;
        padding-right: 24px;
        background-color: #fff;
        border-radius: 5px;
        border-color: #969696;
        text-align: center;
        // margin: 3px;
        padding: 3px;
        -webkit-appearance: none;

        &.first-hours {

          // width: 50%;
          &:after {
            // right: 55%;
          }
        }

        &:focus {
          outline: none;
        }

        &.field-disabled {
          background-color: @greyRicerca !important; //@grayLight !important;
          color: @grayMedium !important; // @grayTesto !important;
          -webkit-text-fill-color: @grayMedium;
          opacity: 1;
          /* required on iOS */
        }
      }
    }
  }
}


.status-saved {
  color: @grayMedium;
}

.status-send {
  color: @orangeMedium;
}

.status-approved {
  color: @greenApproved
}

.status-rejected,
.status-delete {
  color: #f44336
}

.inoltraBtn {
  margin-top: 20px;
}

.popover-mobile {
  line-height: 50px;
  .set-font(@size: 18px, @color: @grayTesto, @family: "os-semibold")
}
</style>



// WEBPACK FOOTER //
// src/components/TrasferteMobile/AutorizzaTrasfertaMobile.vue